import React, { useCallback, useMemo } from "react";
import { AppPage, MimaToastUtil } from "../../components";
import { AnimatePresence } from "framer-motion";
import { useState } from "react";
import constant from "../../utils/constant";
import {
  ApprovePayoutContainer,
  CreatePayoutContainer,
  IgnorePayoutContainer,
  ViewMorePayoutContainer,
} from "../../containers";
import { amountFormatter } from "../../utils/utils";
import moment from "moment";
import MimaCheckboxTable from "../../components/MimaTable/MimaCheckboxTable";

const Payout = ({
  goToIgnore,
  ignoreModal,
  goToApproval,
  approvalModal,
  goToCreatePayout,
  createPayout,
  goToViewMore,
  viewMore,
  closeModal,
  data,
  isLoading,
  isFetching,
  limit,
  onLimitChange,
  currentPage,
  setCurrentPage,
  setSearchQuery,
  selectedIndex,
  setSelectedIndex,
}) => {
  const [payout, setPayout] = useState({});

  const [selectedRows, setSelectedRows] = useState([]);

  const tableData = useMemo(() => {
    if (data?.status === constant.Success) {
      return data?.data?.value || [];
    }
    return [];
  }, [data]);

  const tableColumns = [
    {
      Header: "Partner Name",
      Cell: ({ cell }) => {
        const firstName = cell.row.original.marketer.firstname;
        const lastName = cell.row.original.marketer.lastname;
        const fullName = `${firstName} ${lastName}`;
        return <span>{fullName}</span>;
      },
    },
    {
      Header: "Total Commission",
      accessor: "totalCommission",
      Cell: ({ cell }) => {
        const commission = cell.row.original.totalCommission;
        const formattedCommission = amountFormatter("NGN").format(commission);
        return <span>{formattedCommission}</span>;
      },
    },
    {
      Header: "Date Created",
      accessor: "createdAt",
      Cell: ({ cell }) => {
        const formattedDate = moment(cell.value).format("DD/MM/YY");
        return <span>{formattedDate}</span>;
      },
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ cell }) => {
        const status = cell.row.original.status;
        const statusClass = `status ${
          status === "APPROVED"
            ? "status__green"
            : status === "IGNORED"
              ? "status__dark__yellow"
              : "status__red"
        }`;
        return <span className={statusClass}>{status}</span>;
      },
    },
    {
      Header: "Actions",
      Cell: ({ cell }) => {
        const item = cell.row.original;
        return (
          <span
            className="tableAction__text"
            onClick={() => {
              setPayout(item);
              goToViewMore();
            }}
          >
            View More
          </span>
        );
      },
    },
  ];

  const navItems = ["Create Payout", "Approve Payout", "Ignore Payout"];

  const handleSelectedRowsChange = (newSelectedRows) => {
    setSelectedRows(newSelectedRows);
  };

  const mappedTags = tableData.map((data) => {
    return {
      tag: data.tag,
      status: data.status,
    };
  });

  const isAnyApproved = mappedTags.some((item) => item.status === "APPROVED");

  return (
    <AppPage pageTitle="Partner Payout">
      <>
        <div className="main_nav">
          {navItems?.map((item, i) => (
            <div
              key={i}
              className={
                i === selectedIndex ? "main_nav_item_active" : "main_nav_item"
              }
              onClick={() => {
                setSelectedIndex(i);
                if (item === "Create Payout") {
                  goToCreatePayout();
                } else if (item === "Approve Payout") {
                  goToApproval();
                } else if (item === "Ignore Payout") {
                  if (selectedRows.length > 0 && !isAnyApproved) {
                    goToIgnore();
                  } else if (selectedRows.length > 0 && isAnyApproved) {
                    MimaToastUtil.error({
                      message: "Already approved payout cannot be ignored",
                    });
                  } else {
                    MimaToastUtil.error({
                      message: "Select Payout to ignore",
                    });
                  }
                }
              }}
            >
              {item}
            </div>
          ))}
        </div>
        <MimaCheckboxTable
          tableData={tableData}
          tableColumns={tableColumns}
          searchPlaceholder="Search Payout"
          searchVariant="wide"
          totalItems={data?.data?.totalCounts}
          onLimitChange={onLimitChange}
          isLoading={isLoading}
          isFetching={isFetching}
          limit={limit}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          setSearchQuery={setSearchQuery}
          selectedRows={selectedRows}
          onSelectedRowsChange={handleSelectedRowsChange}
        />

        {(createPayout || viewMore || approvalModal || ignoreModal) && (
          <div className="modal">
            <AnimatePresence>
              {createPayout && (
                <CreatePayoutContainer closeModal={closeModal} />
              )}
              {viewMore && (
                <ViewMorePayoutContainer
                  closeModal={closeModal}
                  payout={payout}
                />
              )}
              {approvalModal && (
                <ApprovePayoutContainer
                  closeModal={closeModal}
                  mappedTags={mappedTags}
                />
              )}
              {ignoreModal && (
                <IgnorePayoutContainer
                  closeModal={closeModal}
                  selectedRows={selectedRows}
                />
              )}
            </AnimatePresence>
          </div>
        )}
      </>
    </AppPage>
  );
};
export default Payout;
